import { useCurrentUser } from 'Auth';

import { useMutation } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { requestMail } from 'scenes/Trackers/Tracker/sources/table';

import { requestMailKey } from '../queryKeyFactory';

export const useRequestMail = () => {
  const { showMessage } = useScreenMessage();
  const user = useCurrentUser();
  const exportMutation = useMutation(requestMailKey(), requestMail, {
    refresh: false,
  });
  const handleAction = async ({ payload, name, page }) => {
    await exportMutation.mutateAsync({
      name,
      payload,
      page,
      recipients: [user],
    });
    showMessage(`You will receive the report in your email when it is ready`);
  };

  return [handleAction, exportMutation];
};
